// SPDX-License-Identifier: MIT
import { AzureBlobItemMeta, AzureHierarchyNode } from '../types';

export function buildHierarchy(
  items: AzureBlobItemMeta[],
  currentPrefix: string
): AzureHierarchyNode[] {
  const root: Record<string, AzureHierarchyNode> = {};
  items.forEach(item => {
    const relative = item.name.substring(currentPrefix.length);
    const parts = relative.split('/').filter(Boolean);
    if (item.isDirectory) {
      const dirName = parts[parts.length - 1];
      root[dirName] = root[dirName] || {
        name: dirName,
        path: item.name,
        isDirectory: true,
        children: [],
      };
    } else if (parts.length === 1) {
      const fileName = parts[0];
      root[fileName] = {
        name: fileName,
        path: item.name,
        isDirectory: false,
        size: item.size,
        meta: item,
      };
    }
  });
  return Object.values(root).sort(
    (a, b) => Number(b.isDirectory) - Number(a.isDirectory) || a.name.localeCompare(b.name)
  );
}
